module.exports = __webpack_public_path__ + "media/images/checkout/gps-65c26e19661a9eff0b54065a453c2313.png";